import { sourcePath } from "../utils/path";

const Img = ({ src, ...rest }) => {
	return (
		<img
			src={src.replace("./", sourcePath)}
			{...rest}
		/>
	);
};
export default Img;
